<form #form="ngForm" (ngSubmit)="changePassword()">
  <div class="modal-header">
    <h4 class="modal-title">Cambio de Contraseña</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close(false)"></button>
  </div>
  <div class="modal-body">
    <p>Ingrese su nueva contraseña a continuación.</p>

    @if (showCurrentPassword()){
    <div class="row mb-3">
      <div class="col">
        <div class=" ">
          <label for="template" class="form-label  ">Contraseña Actual</label>
          <input class="form-control" type="password" id="currentPassword" name="currentPassword"
            label="Contraseña Actual"
            [appAutofocus]="true"
            [(ngModel)]="currentPassword" />
        </div>
      </div>
    </div>
    }


    <div class="row mb-3">
      <div class="col">
        <div class="">
          <label for="template" class="form-label  ">Contraseña</label>
          <app-password-input [required]="true" id="password" name="password" label="Contraseña"
            [appAutofocus]="!showCurrentPassword()"
            [(ngModel)]="password"></app-password-input>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col">
        <div class="">
          <label for="template" class="form-label  ">Reingrese Contraseña</label>
          <app-password-input [required]="true" id="confirmPassword" name="confirmPassword"
            label="Reingrese Contraseña"
            [showPolicy]="false"
            [(ngModel)]="confirmPassword"></app-password-input>
        </div>
      </div>
    </div>
    <app-problem-details [listenFor]="'password-change'"></app-problem-details>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" [disabled]="!valid()">Acceptar</button>
    <button type="button" class="btn btn-outline-secondary" (click)="close(false)">Cancelar</button>

  </div>



</form>